module.exports = __webpack_public_path__ + "img/mh.ec211b56.svg";